import React, {  useRef, useState } from 'react';

import styled from 'styled-components'
import './addpost.css'
import { getAuth, } from "firebase/auth";
import { collection,  setDoc, doc,  deleteDoc, getDocs, query,serverTimestamp } from "firebase/firestore"; 
import { getFirestore } from "firebase/firestore"
import {  ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useEffect } from 'react';



const Cocktail = () => {
    const [refresh,setRefresh] = useState(false)
    const [getDataOnce, setGetDataOnce] = useState(true)
    const formref = useRef()
    const auth = getAuth();
    const db = getFirestore()
    const [cocktailList,setCocktailList] = useState([])
    const[cocktail, setCocktail] = useState({
        title: '',
        ingredient:'',
        type:'',
        prix:''
    });
  

   
    const getDataCocktail = async () => {

      
        let completeList = []
        const q = query(collection(db, "cocktails"));
        const querySnapshot = await getDocs(q);
        const pushArray = async () => {
            
        await querySnapshot.forEach((doc) => {
    
                
                completeList.push({ id: doc.id, title: doc.data().title, ingredient: doc.data().ingredient})
                
            })}   
        pushArray();
         
       setCocktailList(completeList)
       
        
    }
           
        
    const handleChange = (e) => {
        
        if(e.target.name === 'title'){
            setCocktail({...cocktail, title: e.target.value})
        }
        
        if(e.target.name === 'ingredient'){
            setCocktail({...cocktail, ingredient: e.target.value})
        }

         if(e.target.name === 'type'){
            setCocktail({...cocktail, type: e.target.value})
        }
         if(e.target.name === 'prix'){
            setCocktail({...cocktail, prix: e.target.value})
        }
                
        
        
    }

    const handleClick = async (e) => {
        e.preventDefault()

        const timestamp = serverTimestamp()       
                  

    
        await setDoc(doc(db, "cocktails", cocktail.title ), {
        title: cocktail.title,
        ingredient: cocktail.ingredient,     
        type: cocktail.type  ,
        prix: cocktail.prix,
        createdAt: timestamp
        
        
        });

        
        toast.success('Cocktail enregistré!', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });

        
        await setCocktail({ title: '',
        ingredient: '',
        type: cocktail.type,
        prix:''
        })
        
        setRefresh(!refresh)
     
      

         }


         useEffect(()=>{
             
           getDataCocktail()               
            
            
         },[refresh])


         
        const handleDelete = async (id) => {
            
            toast.error('Cocktail supprimé', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
           
            const deleteAction = async () => {

                await deleteDoc(doc(db, "cocktails",id ));
            }
            await deleteAction();  
             setRefresh(!refresh)
           
            

        }

      

        
             
    
   
        

    return (
        <Container>
            <ToastContainer/>

            <div className="content">
              < div className='form'  > 
                
                    <label htmlFor="title">Nom du cocktail</label>
                    <input maxLength={80} className="input" type="text" name="title" id="title"  onChange={handleChange} value={cocktail.title} />  
                    <div className="halfpart">
                     <label htmlFor="type">Type</label>
                    {/* <input maxLength={80} className="input" type="text" name="type" id="type" placeholder='min singulier' onChange={handleChange} value={cocktail.type} />   */}
                    <select name="type" id="type"  onChange={handleChange}>
                        <option value="">Please choose an option</option>
                        <option value="biere">biere</option>
                        <option value="biere aromatisee">biere aromatisee</option>
                        <option value="biere blanche">biere blanche</option>
                        <option value="biere blonde">biere blonde</option>
                        <option value="biere brune">biere brune</option>
                        <option value="biere pression">biere pression</option>
                        <option value="bourbon">bourbon</option>
                        <option value="digestif">digestif</option>
                        <option value="fresh drink">fresh drink</option>
                        <option value="gin">gin</option>
                        <option value="japan whisky">japan whisky</option>
                        <option value="mojito">mojito</option>
                        <option value="les classiques">les classiques</option>
                        <option value="long drink">long drink</option>
                        <option value="sans alcool">sans alcool</option>
                        <option value="short drink">short drink</option>
                        <option value="scotch whisky">scotch whisky</option>
                        <option value="soft">soft</option>
                        <option value="tequila">tequila</option>
                        <option value="vodka">vodka</option>
                        <option value="vin&champagne">vin & champagne</option>
                    </select>
                     <label htmlFor="Prix">Prix</label>
                    <input maxLength={80} className="input" type="text" name="prix" id="prix"  onChange={handleChange} value={cocktail.prix} />  
                        
                    </div>  
                                    
                    <label htmlFor="ingredient">Liste des ingredients</label>
                    <textarea  className="area"  name="ingredient" id="ingredient"  onChange={handleChange} value={cocktail.ingredient} />
                    
            
                  
                   
                    <div className="footer">
                      <p className='buttonAddpost'  onClick={handleClick}>Publier</p> 
                     
                   

                    </div>
            
                </div> 

                
           
            </div>
            <div className="list_cocktail">

                {cocktailList.map((cocktail,index) => {

                    return (
                        <div className="cocktail" key={index}>
                              <p>{cocktail.title}</p>
                              <p>{cocktail.type}</p>
                              <button onClick={() => handleDelete(cocktail.title)}>Supprimer</button>
                        </div>

                    )
                     


                })}
               
               
            </div>
                
               
            

        </Container>
    );


};

const Container = styled.div`
height: 100%;
width: 100%;
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
overflow-y: scroll;

::webkit-scrollbar{
    display:none;
}


.list_cocktail{
    overflow-y: scroll;
    
    width: 100%;
    height: 40%;
    border-top: 1px solid #ccc;
    position:absolute;
    bottom: 10px;
    
    
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 22px 0px 10px 0px;

    .cocktail{
        font-size: 14px;
        font-weight: 600;
        display:flex;
        justify-content: space-between;
        align-items:center;
        width: 90%;
        border-bottom: 1px solid #ccc;
        
        padding: 2px 0px;
    }
    button{
        border: none;
        border-radius: 5px;
        background-color: #ccc;
        padding: 5px 5px;
        font-weight: 700;
        color:#000;
        font-family:'Lobster';
        font-size:14px;
    }
    
}
   ::-webkit-scrollbar{
    display:none;
}
  



.content{
    width: 100%;
    height: 40%;
   
    display:flex;
    justify-content: center;
    align-items: flex-start;
   

    .form{
    position: relative;
    top:30px;

   
    
    
    
    
    width: 90%;
    height: 100%;
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items:flex-start;
    gap: 10px;

    .halfpart{
        display:flex;
        justify-content: center;
        align-items:center;
    }

    .halfpart:nth-child(1){
        width:50%:
    }
     .halfpart:nth-child(2){
        width:50%:
    }

    #type{
        background-color: rgb(160,160,246, 0.8);
        width: 70%;
        border:none;
        outline:none;
        
    }
    

    form{
        display:flex;
        flex-direction: column;
    }

    
    
  
    
}


}


    

`
export default Cocktail;